import React, { useState } from "react";
import classes from "./detailpage.module.css";
import { env } from "../../constants/env";

const DepositSettings = ({depositSettings, companyId, getCompany}) => {
  const [isEdit, setIsEdit] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [selectedOption, setSelectedOption] = useState();

  const updateDepositSettingsHandler = async () => {
    let dataContent = {depositSettings: selectedOption}
    const sendRequest = async () => {
      setIsSending(true)
      const response = await fetch(`${env.primeBridgeUrl}/api/company/update-deposit/${companyId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataContent)
      });

      if (!response.ok) {
        setIsSending(false)
        const error = await response.json();
        console.log("ERRORRR", error)
        throw new Error("sending plays failed.");
      }

      const result = await response.json();

      setIsEdit(false)
      getCompany()

      console.log("Reply from plays data", result);

      return result;
    };

    try {
      await sendRequest();
    } catch (error) {
      setIsSending(false)
      console.log(error);
    }
  };
  return (
    <div className={classes.transactionItem}>
      <p className={classes.transactionText}>
        Deposit Settings:{" "}
        {!isEdit && (
          <span>
            {depositSettings ? +depositSettings * 100 : 0}%{" "}
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              onClick={() => setIsEdit(true)}
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.35082 1.01441C10.4634 -0.0981163 12.2671 -0.098116 13.3796 1.01441L14.1854 1.82018C15.2979 2.93271 15.2979 4.73648 14.1854 5.84901L4.91911 15.1153L1.22404 15.1153C0.594699 15.1153 0.0845151 14.6051 0.0845156 13.9758L0.0845146 10.2807L9.35082 1.01441ZM11.7681 2.62595L12.5739 3.43171C12.7964 3.65422 12.7964 4.01497 12.5739 4.23748L11.3652 5.44613L9.7537 3.83459L10.9624 2.62595C11.1849 2.40344 11.5456 2.40344 11.7681 2.62595ZM9.7537 7.05766L3.9751 12.8363L2.36356 12.8363L2.36356 11.2247L8.14217 5.44613L9.7537 7.05766Z"
                fill="#0077B5"
              />
            </svg>
          </span>
        )}
      </p>
      {isEdit && (
        <div className={classes.transactionEdit}>
          <select onChange={(e) => setSelectedOption(e.target.value)}>
            <option selected={depositSettings === "0" && depositSettings} value="0">0%</option>
            <option selected={depositSettings === "0.05" && depositSettings} value="0.05">5%</option>
            <option selected={depositSettings === "0.10" && depositSettings} value="0.10">10%</option>
            <option selected={depositSettings === "0.15" && depositSettings} value="0.15">15%</option>
          </select>

          <button onClick={updateDepositSettingsHandler}>Save</button>
        </div>
      )}
    </div>
  );
};

export default DepositSettings;
